interface EmailPayload {
  name: string;
  email: string;
  message: string;
  browserInfo?: {
    userAgent: string;
    language: string;
    platform: string;
    screenResolution: string;
    windowSize: string;
    timeZone: string;
    cookiesEnabled: boolean;
    doNotTrack: string | null;
    referrer: string;
    connectionType?: string;
    deviceMemory?: string;
    devicePixelRatio: number;
    vendor: string;
    renderingEngine: string;
  };
}

interface EmailResponse {
  success: boolean;
  message: string;
  error?: {
    message: string;
  };
}

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export class EmailError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EmailError';
  }
}

export const sendEmail = async (payload: EmailPayload): Promise<EmailResponse> => {
  try {
    const response = await fetch(`${API_URL}/api/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = (await response.json()) as EmailResponse;

    if (!response.ok) {
      throw new EmailError(data.error?.message ?? data.message ?? 'Failed to send message');
    }

    return data;
  } catch (error) {
    if (error instanceof EmailError) {
      throw error;
    }

    // Log error in development
    if (import.meta.env.DEV) {
      console.error('Email service error:', error);
    }

    throw new EmailError(
      error instanceof Error ? error.message : 'Failed to send message. Please try again.'
    );
  }
};
